import React from "react";
import { Form } from "react-bootstrap";
import { TMonthOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import MonthsSelector from "../../../MonthsSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TMonthOption;
}

const ForecastMonthsField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="months">
      <Form.Label>Forecast months</Form.Label>
      <MonthsSelector
        values={formik.values.fcmonth}
        spec={spec}
        onChange={values => formik.setFieldValue('fcmonth', values)}
      />

      <FormError
        message={formik.errors.fcmonth as TFormErrorMessage}
        when={formik.touched.fcmonth && Boolean(formik.errors.fcmonth)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ForecastMonthsField;
